module.exports = __webpack_public_path__ + "static/media/lolol_food_voucher_app.1bfe07fb.jpg";